import { useBeforeSetting } from "@/store/beforeSetting";
import { getWhatsAppChannelUrl } from "./channelUrl";

export default function useWhatsAppChannel() {
  const { data } = useBeforeSetting();
  // 后台复用旧的 telegramGroup 字段；whatsapp 字段仍用于客服。
  return getWhatsAppChannelUrl(data?.telegramGroup);
}
